import * as React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import dayjs, { Dayjs } from 'dayjs';

/**
 * Editor "solo anno" per celle di `DataGrid`/`CrudDataGrid` (es. anno di entrata in esercizio).
 * Il valore resta una Date (1° gennaio dell'anno scelto): nessun impatto su schema/API, cambia
 * solo l'editor mostrato all'utente. Analogo a `MonthDatePicker` ma con `views={['year']}`.
 */
export const YearDatePicker: React.FC<GridRenderEditCellParams> = ({ id, value, field, api }) => {
  const [dateValue, setDateValue] = React.useState<Dayjs | null>(value ? dayjs(value) : null);

  const handleChange = (newValue: Dayjs | null) => {
    setDateValue(newValue);
    if (newValue) {
      const firstDayOfYear = newValue.startOf('year').toDate();
      api.setEditCellValue({ id, field, value: firstDayOfYear });
    } else {
      api.setEditCellValue({ id, field, value: null });
    }
  };

  React.useEffect(() => {
    setDateValue(value ? dayjs(value) : null);
  }, [value]);

  return (
    <DatePicker
      value={dateValue}
      onChange={handleChange}
      views={['year']}
      format="YYYY"
      slotProps={{
        textField: {
          size: 'small',
          variant: 'outlined',
          fullWidth: true,
          sx: { height: '100%' },
        },
      }}
      sx={{ width: '100%' }}
    />
  );
};
